// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"DashboardPageLayout_hideScrollbar__0L4Gd"};